export default [
  {
    path: '/document_bundles',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'document-bundles-list' */ '@/views/document_bundles/List.vue')
  }
]
